module.exports = __webpack_public_path__ + "static/media/buat-laporan.e8f94314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/buat-laporan.svg
// module id = 67
// module chunks = 1